<template>
  <div class="bx-content bx-typo--form bx-typo--form-contact">
    <form class="bx-form bx-form--pur bx-form--pwr-converter"
          novalidate
          @submit.prevent="convert(true)">
      <div class="bx-form__checkbox-wrapper">
        <div class="bx-content__interline bx-typo--content-interline">
          Umrechnungsart
        </div>
        <div>
          <label for="ps"
                 class="bx-form__label">PS nach kW, hp</label>
          <input id="ps"
                 v-model="unit"
                 type="radio"
                 value="PS"
                 checked>
        </div>
        <div>
          <label for="kw"
                 class="bx-form__label">kW nach PS, hp</label>
          <input id="kw"
                 v-model="unit"
                 type="radio"
                 value="kW">
        </div>
        <div>
          <label for="hp"
                 class="bx-form__label">hp nach kW, PS</label>
          <input id="hp"
                 v-model="unit"
                 type="radio"
                 value="hp">
        </div>
      </div>
      <div class="bx-form__input-wrapper"
           :class="{'bx-has-error': errorMsg}">
        <div class="bx-content__interline bx-typo--content-interline">
          Ausgangswert
        </div>
        <label for="value"
               class="bx-form__label">Leistung in {{ unit }}
          <span class="bx-form__required"
                title="Diese Angabe wird benötigt.">*
          </span>
        </label>
        <input id="value"
               v-model="value"
               type="number"
               placeholder="z.B. 100"
               @keydown="preventNonPositiveNumberKeys">
        <span v-if="errorMsg"
              class="bx-form__message bx-form__message--error">
          {{ errorMsg }}
        </span>
      </div>
      <button type="submit"
              class="bx-form__button">
        Umrechnen
      </button>
      <div class="bx-form__disclaimer-required">
        * Pflichtfeld
      </div>
      <div v-if="stringValue.length && results.length && !errorMsg"
           class="bx-affiliate-link bx-form__result bx-typo--content-interline">
        <span><strong>{{ commaSeparatedValue }} {{ unit }}</strong> entsprechen</span>
        <br><strong>{{ results[0].value }} {{ renderUnits[results[0].unit] }}</strong>
        bzw. <strong>{{ results[1].value }} {{ renderUnits[results[1].unit] }}</strong>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { ref } from 'vue'

import EventBus from '../../../../event-bus/EventBus'
import { useAdaMoltenBundle } from '../../../../composables/use-ada-molten-bundle'
import { preventNonPositiveNumberKeys } from '.././../../../utils/validation/number'
import { useDeviceDetection } from '../../../../composables/use-device-detection'
import { useConfigStore } from '../../../../stores/config'

export default {
  name: 'ParagraphTypeHpKwConverter',
  setup () {
    const { deviceType, ...deviceDetection } = useDeviceDetection()
    const registerSlots = ref([])
    const moltenBundle = useAdaMoltenBundle({ registerSlots, deviceType })
    return { ...deviceDetection, deviceType, registerSlots, ...moltenBundle, preventNonPositiveNumberKeys }
  },
  data () {
    return {
      value: null,
      unit: 'PS',
      results: [],
      multiplier: {
        ps: {
          kw: 0.735499,
          hp: 0.986320
        },
        kw: {
          ps: 1.35962,
          hp: 1.34102
        },
        hp: {
          ps: 1.01387,
          kw: 0.7457
        }
      },
      errorMsg: null,
      renderUnits: {
        ps: 'PS',
        kw: 'kW',
        hp: 'hp'
      }
    }
  },
  computed: {
    ...mapState(useConfigStore, ['rsConfig']),
    reloadConfig () {
      return { ...this.rsConfig.adSlotUsage.reloadAdsOnInteraction.config, ...{ minDisplayDuration: 0, clickCount: 1 } }
    },
    stringValue () {
      return String(this.value || '')
    },
    splitValues () {
      return this.stringValue.split(/[.,]/)
    },
    commaSeparatedValue () {
      return this.stringValue.replace('.', ',')
    }
  },
  watch: {
    unit () {
      this.value = null
      this.results = []
    },
    value () {
      this.errorMsg = null
      this.results = []
    }
  },
  methods: {
    validForm () {
      this.errorMsg = null

      if ((this.stringValue.length === 0 || this.value === null) && this.value !== 0) {
        this.errorMsg = 'Der Ausgangswert muss zur Berechnung eingegeben werden.'
      } else if (this.splitValues[0].length > 4) {
        this.errorMsg = 'Es werden nur Ausgangswerte mit maximal vier Stellen unterstützt.'
      } else if (this.value <= 0) {
        this.errorMsg = 'Der Ausgangswert muss eine positive Zahl sein.'
      } else if (this.splitValues[1] && this.splitValues[1].length > 2) {
        this.errorMsg = 'Es werden nur Ausgangswerte mit maximal zwei Nachkommastellen unterstützt.'
      }

      return !this.errorMsg
    },
    convert (reloadAds = false) {
      if (!this.validForm()) return

      const from = this.unit.toLowerCase()
      const targets = this.multiplier[from]
      this.results = Object.entries(targets).map(([unit, factor]) => ({
        unit,
        value: (this.value * factor).toFixed(2).replace('.', ',')
      }))

      if (reloadAds) {
        EventBus.$emit('triggerAGF')
        this.adaSlotReloadOnInteraction(this.reloadConfig)
      }
    }
  }
}
</script>
